import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Role } from "~/utils/Classes/Role";
export var name = 'roles';
export var state = function state() {
  return {
    roles: [],
    userId: null,
    userEmail: null,
    roleSearchType: 'all'
  };
};
export var mutations = {
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_USER_ID: function SET_USER_ID(state, id) {
    state.userId = id;
  },
  SET_USER_EMAIL: function SET_USER_EMAIL(state, email) {
    state.userEmail = email;
  },
  SET_ROLE_SEARCH_TYPE: function SET_ROLE_SEARCH_TYPE(state, type) {
    state.roleSearchType = type;
  }
};
export var actions = {
  manageRoles: function manageRoles(_ref, roleModels) {
    var commit = _ref.commit;
    var roles = [];

    var _iterator = _createForOfIteratorHelper(roleModels),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var role = _step.value;
        roles.push(new Role(role));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    commit('SET_ROLES', roles);
  },
  removeRole: function removeRole(_ref2, roleId) {
    var commit = _ref2.commit,
        state = _ref2.state;
    var filteredRoles = state.roles.filter(function (role) {
      return role.id != roleId;
    });
    commit('SET_ROLES', filteredRoles);
  },
  setRoleSearchType: function setRoleSearchType(_ref3, type) {
    var commit = _ref3.commit,
        state = _ref3.state;
    commit('SET_ROLE_SEARCH_TYPE', type);
  },
  setUserId: function setUserId(_ref4, id) {
    var commit = _ref4.commit,
        state = _ref4.state;
    commit('SET_USER_ID', id);
  },
  setUserEmail: function setUserEmail(_ref5, email) {
    var commit = _ref5.commit,
        state = _ref5.state;
    commit('SET_USER_EMAIL', email);
  }
};